import React from 'react';

const src = 'https://1000logos.net/wp-content/uploads/2017/03/LinkedIn-Logo.png';

export function LinkedInLogo(props) {
  return (
    <img className={ `linkedin-logo ${ props.className ? props.className : '' }` } src={ src } alt="linkedin" />
  )
}